<template>
  <div class="slide-box">
    <div class="tv-box"></div>
    <div class="slide-number">
      <div :class="[box1, {'stop-current': stop}]">
        <img :src="img1">
      </div>
      <div :class="[box2, {'stop-next': stop}]">
        <img :src="img2">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SlideNumber',
  props: {
    startNumber: {
      type: Number,
      default: 0
    },
    resultNumber: {
      type: String,
      default: null
    },
    timeout: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      TimeoutToShow: null,
      spinTimeout: null,
      count: 0,
      no1: 0,
      no2: 1,
      box1: 'slider-current slideOut',
      box2: 'slider-next slideIn',
      stop: false,
      endNumber: 0
    }
  },
  computed: {
    img1() {
      return require(`@/assets/${(this.no1%10).toString()}.png`)
    },
    img2() {
      return require(`@/assets/${(this.no2%10).toString()}.png`)
    }
  },
  watch: {
    timeout(n, o) {
      if(n!==o) {
        console.log('re_spinning...', this.timeout)
        this.startSpin()
      }
    }
  },
  methods: {
    startSpin(reset=true) {
      // หมุนเร็ว
      if(reset) {
        console.log('reset spin')
        this.count = 0
        this.no1 = 0
        this.no2 = 1
        this.box1 = 'slider-current slideOut'
        this.box2 = 'slider-next slideIn'
        this.stop = false
      }
      this.speedFast()

      let timeout = this.timeout > 1000 ? this.timeout : 10000
      clearTimeout(this.TimeoutToShow)
      this.TimeoutToShow = setTimeout(()=>{
        if(this.resultNumber) {
          console.log('มีผลแล้ว เริ่มขั้นตอนหมุนเพื่อแสดงผล')
          this.box1 = 'slider-current slideOut'
          this.box2 = 'slider-next slideIn'
          this.stop = false
          this.speedShow()
        }else{
          console.log('ยังไม่มีผล หมุนต่ออีก 10 วิ')
          this.startSpin(false)
        }
      }, timeout)
    },
    speedShow() {
      this.endNumber = 110 + parseInt(this.resultNumber) + this.startNumber
      this.count = this.startNumber
      this.no1 = 0 //this.startNumber
      this.no2 = 1 //this.startNumber + 1
      this.speed(50)
    },
    speedFast() {
      clearTimeout(this.spinTimeout)
      this.spinTimeout = setTimeout(()=>{
        this.count++
        let box = this.count%2
        if(box === 0) {
          this.no2+=2
          this.box1 = 'slider-current slideOutSpeed1'
          this.box2 = 'slider-next slideInSpeed1'
        }else{
          this.no1+=2
          this.box1 = 'slider-next slideInSpeed1'
          this.box2 = 'slider-current slideOutSpeed1'
        }
        this.speedFast()
      }, 50)
    },
    speed(times) {
      clearTimeout(this.spinTimeout)
      this.spinTimeout = setTimeout(()=>{
        this.count++
        let box = this.count%2
        if(box === 0) {
          this.no2+=2

          if(this.count >= 110) {
            this.box1 = 'slider-current slideOutSpeed6'
            this.box2 = 'slider-next slideInSpeed6'
            times = 500
          }else
          if(this.count >= 105){
            this.box1 = 'slider-current slideOutSpeed5'
            this.box2 = 'slider-next slideInSpeed5'
            times = 400
          }else
          if(this.count >= 95){
            this.box1 = 'slider-current slideOutSpeed4'
            this.box2 = 'slider-next slideInSpeed4'
            times = 300
          }else
          if(this.count >= 80){
            this.box1 = 'slider-current slideOutSpeed3'
            this.box2 = 'slider-next slideInSpeed3'
            times = 200
          }else
          if(this.count >= 60){
            this.box1 = 'slider-current slideOutSpeed2'
            this.box2 = 'slider-next slideInSpeed2'
            times = 100
          }else{
            this.box1 = 'slider-current slideOutSpeed1'
            this.box2 = 'slider-next slideInSpeed1'
            times = 50
          }

        }else{
          this.no1+=2

          if(this.count >= 110) {
            this.box1 = 'slider-next slideInSpeed6'
            this.box2 = 'slider-current slideOutSpeed6'
            times = 500
          }else
          if(this.count >= 105){
            this.box1 = 'slider-next slideInSpeed5'
            this.box2 = 'slider-current slideOutSpeed5'
            times = 400
          }else
          if(this.count >= 95){
            this.box1 = 'slider-next slideInSpeed4'
            this.box2 = 'slider-current slideOutSpeed4'
            times = 300
          }else
          if(this.count >= 80){
            this.box1 = 'slider-next slideInSpeed3'
            this.box2 = 'slider-current slideOutSpeed3'
            times = 200
          }else
          if(this.count >= 60){
            this.box1 = 'slider-next slideInSpeed2'
            this.box2 = 'slider-current slideOutSpeed2'
            times = 100
          }else{
            this.box1 = 'slider-next slideInSpeed1'
            this.box2 = 'slider-current slideOutSpeed1'
            times = 50
          }

        }

        if(this.count >= this.endNumber){
          if((this.count%2) === 0) {
            this.no2--
          }else{
            this.box2 = ''
          }
          this.stop = true
        }else{
          //console.log(this.count, times)
          this.speed(times)
        }
      }, times)
    },
    speedTest() {
      clearTimeout(this.spinTimeout)
      this.spinTimeout = setTimeout(()=>{
        this.count++
        let box = this.count%2
        if(box === 0) {
          this.no2+=2
          this.box1 = 'slider-current slideOutSpeed6'
          this.box2 = 'slider-next slideInSpeed6'
        }else{
          this.no1+=2
          this.box1 = 'slider-next slideInSpeed6'
          this.box2 = 'slider-current slideOutSpeed6'
        }
        this.speedTest()
      }, 500)
    },
  },
  mounted() {
    console.log('mounted!!!')
    this.startSpin()
  },
  beforeDestroy() {

  }
}
</script>
<style lang="scss" scoped>
.slide-box {
  position: relative;
  width: 120px;
  height: 125px;

  .tv-box {
    position: absolute;
    z-index: 100;
  }
  .slide-number {
    height: 70px;
    width: 90px;
    top: 32px;
    left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    background-color: #fff;
    border-radius: 10px;
    z-index: 99;

    .slider-current {
      width: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-content: center;
      left: 0;
    }

    .slider-next {
      width: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-content: center;
      left: 100%;
    }

    img {
      margin: 0 4px;
    }

    .stop-current {
      //left: -100%;
      display: none;
    }

    .stop-next {
      left: 0;
    }
  }
}

@media only screen and (max-width:700px) {
  .slide-box {
    width: 100px;
    height: 105px;

    .slide-number {
      height: 60px;
      width: 70px;
      top: 25px;
      left: 10px;
      padding-top: 3px;

      img {
        width: 40px;
      }
    }
  }
}

@media only screen and (max-width:600px) {
  .slide-box {
    width: 85px;
    height: 90px;

    .slide-number {
      height: 48px;
      width: 57px;
      top: 24px;
      left: 10px;
      padding-top: 3px;

      img {
        width: 35px;
      }
    }
  }
}

@media only screen and (max-width:500px) {
  .slide-box {
    width: 65px;
    height: 61px;

    .slide-number {
      height: 38px;
      width: 50px;
      top: 13px;
      left: 5px;
      padding-top: 3px;

      img {
        width: 30px;
      }
    }
  }
}

// Speed 1
@-webkit-keyframes slideInSpeed1 {
  100% {
    left: 0;
  }
}

@keyframes slideInSpeed1 {
  100% {
    left: 0;
  }
}

.slideInSpeed1 {
  left: -100%;
  -webkit-animation: slideInSpeed1 0.05s linear;
  animation: slideInSpeed1 0.05s linear;
}

@-webkit-keyframes slideOutSpeed1 {
  100% {
    left: -100%;
  }
}

@keyframes slideOutSpeed1 {
  100% {
    left: -100%;
  }
}

.slideOutSpeed1 {
  -webkit-animation: slideOutSpeed1 0.05s linear;
  animation: slideOutSpeed1 0.05s linear;
}

// Speed 2
@-webkit-keyframes slideInSpeed2 {
  100% {
    left: 0;
  }
}

@keyframes slideInSpeed2 {
  100% {
    left: 0;
  }
}

.slideInSpeed2 {
  left: -100%;
  -webkit-animation: slideInSpeed2 0.1s linear;
  animation: slideInSpeed2 0.1s linear;
}

@-webkit-keyframes slideOutSpeed2 {
  100% {
    left: -100%;
  }
}

@keyframes slideOutSpeed2 {
  100% {
    left: -100%;
  }
}

.slideOutSpeed2 {
  -webkit-animation: slideOutSpeed2 0.1s linear;
  animation: slideOutSpeed2 0.1s linear;
}

// Speed 3
@-webkit-keyframes slideInSpeed3 {
  100% {
    left: 0;
  }
}

@keyframes slideInSpeed3 {
  100% {
    left: 0;
  }
}

.slideInSpeed3 {
  left: -100%;
  -webkit-animation: slideInSpeed3 0.2s linear;
  animation: slideInSpeed3 0.2s linear;
}

@-webkit-keyframes slideOutSpeed3 {
  100% {
    left: -100%;
  }
}

@keyframes slideOutSpeed3 {
  100% {
    left: -100%;
  }
}

.slideOutSpeed3 {
  -webkit-animation: slideOutSpeed3 0.2s linear;
  animation: slideOutSpeed3 0.2s linear;
}

// Speed 4
@-webkit-keyframes slideInSpeed4 {
  100% {
    left: 0;
  }
}

@keyframes slideInSpeed4 {
  100% {
    left: 0;
  }
}

.slideInSpeed4 {
  left: -100%;
  -webkit-animation: slideInSpeed4 0.3s linear;
  animation: slideInSpeed4 0.3s linear;
}

@-webkit-keyframes slideOutSpeed4 {
  100% {
    left: -100%;
  }
}

@keyframes slideOutSpeed4 {
  100% {
    left: -100%;
  }
}

.slideOutSpeed4 {
  -webkit-animation: slideOutSpeed4 0.3s linear;
  animation: slideOutSpeed4 0.3s linear;
}

// Speed 5
@-webkit-keyframes slideInSpeed5 {
  100% {
    left: 0;
  }
}

@keyframes slideInSpeed5 {
  100% {
    left: 0;
  }
}

.slideInSpeed5 {
  left: -100%;
  -webkit-animation: slideInSpeed5 0.4s linear;
  animation: slideInSpeed5 0.4s linear;
}

@-webkit-keyframes slideOutSpeed5 {
  100% {
    left: -100%;
  }
}

@keyframes slideOutSpeed5 {
  100% {
    left: -100%;
  }
}

.slideOutSpeed5 {
  -webkit-animation: slideOutSpeed5 0.4s linear;
  animation: slideOutSpeed5 0.4s linear;
}

// Speed 6
@-webkit-keyframes slideInSpeed6 {
  100% {
    left: 0;
  }
}

@keyframes slideInSpeed6 {
  100% {
    left: 0;
  }
}

.slideInSpeed6 {
  left: -100%;
  -webkit-animation: slideInSpeed6 0.5s linear;
  animation: slideInSpeed6 0.5s linear;
}

@-webkit-keyframes slideOutSpeed6 {
  100% {
    left: -100%;
  }
}

@keyframes slideOutSpeed6 {
  100% {
    left: -100%;
  }
}

.slideOutSpeed6 {
  -webkit-animation: slideOutSpeed6 0.5s linear;
  animation: slideOutSpeed6 0.5s linear;
}
</style>
